// import React, { useState } from "react";
// import "./Myprofile.scss";
// import Form from "react-bootstrap/Form";
// import { useLocation } from "react-router-dom";
// import axios from "axios";
// import moment from "moment";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { useNavigate } from "react-router-dom";
// import { Button, Spinner } from "react-bootstrap";
// import APP_BASE_URL from "../../components/Api/globalApi";

// const Myprofile = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const data = location.state?.data || {};
//   const status = location.state?.status || {};
//   console.log(status, data, 'gjhsgdjhsgd');

//   const newDate = status.data
//     ? moment(status.data.dob).format("YYYY-MM-DD")
//     : "";

//   const initialFormData = {
//     first_name: data.user_name,
//     dob: newDate || "",
//     address: "",
//     state: "",
//     district: "",
//     pincode: "",
//     contact_number: data.user_mobile,
//     alternative_number: "",
//     bank_name: "",
//     account_name: "",
//     account_number: "",
//     ifsc_code: "",
//     branch_name: "",
//     image: "",
//   };

//   if (status.result === false) {
//     Object.assign(initialFormData, status.data);
//     initialFormData.image = `https://api.springwayhub.com/${status.data.image}`;
//   }

//   const [formData, setFormData] = useState(initialFormData);
//   const [image, setImage] = useState(null);
//   const [imagePreview, setImagePreview] = useState(
//     status.result === false ? initialFormData.image : null
//   );
//   const [Loading, setLoading] = useState(false);

//   const notify = (message) => {
//     toast(message);
//   };

//   const onHandleChange = (e) => {
//     const { id, value } = e.target;
//     console.log(value);
//     setFormData((prevFormData) => ({
//       ...prevFormData,
//       [id]: value,
//     }));
//   };

//   const handleImage = (e) => {
//     const file = e.target.files[0];
//     setImage(file);

//     const reader = new FileReader();
//     reader.onloadend = () => {
//       setImagePreview(reader.result);
//     };
//     reader.readAsDataURL(file);
//   };

//   const handleButtonClick = async (e) => {
//     setLoading(true);
//     e.preventDefault();
//     const response = await axios.post(
//       `${APP_BASE_URL}/update/username`,
//       { username: formData.first_name },
//       {
//         headers: {
//           u_id: data.user_id,
//         },
//       }
//     );
//     setLoading(false);
//     alert(response.data.message);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       const formDataToSend = new FormData();
//       for (const key in formData) {
//         formDataToSend.append(key, formData[key]);
//       }
//       if (image) {
//         formDataToSend.append("image", image);
//       }

//       const response = await axios.post(
//         `${APP_BASE_URL}/myprofile`,
//         formDataToSend,
//         {
//           headers: {
//             "Content-Type": "multipart/form-data",
//             user_id: data.user_id,
//             api_key: data.user_api_key,
//           },
//         }
//       );

//       if (response.data.result === true) {
//         notify(response.data.message);
//         navigate("/home");
//       }
//     } catch (error) {
//       console.log(error);
//     }
//   };

//   const imageFixer =
//     imagePreview ||
//     "https://static.vecteezy.com/system/resources/thumbnails/005/544/718/small_2x/profile-icon-design-free-vector.jpg";

//   return (
//     <div className="container-fluid pro">
//       <form onSubmit={handleSubmit}>
//         <h4>My Profile</h4>

//         <div className="pro-image">
//           <Form.Control
//             className="control"
//             type="file"
//             name="image"
//             onChange={handleImage}
//           />
//           <div className="image-holder">
//             <img
//               src={imageFixer}
//               alt="Preview"
//               style={{ maxWidth: "200px", maxHeight: "200px" }}
//             />
//           </div>
//         </div>

//         <Form.Group className="d-flex align-items-center">
//           <div className="flex-grow-1 me-2">
//             <Form.Label htmlFor="first_name">User Name</Form.Label>
//             <Form.Control
//               type="text"
//               id="first_name"
//               value={formData.first_name}
//               onChange={onHandleChange}
//             />
//           </div>
//           <Button
//             variant="primary"
//             type="button"
//             onClick={handleButtonClick}
//             disabled={Loading}
//             style={{
//               padding: "4px 10px",
//               fontSize: "12px",
//               lineHeight: "1",
//               minWidth: "70px",
//               borderRadius: "4px",
//               width: "100px",
//               height: "40px",
//               bottom: "30px",
//             }}
//           >
//             {Loading ? (
//               <>
//                 <Spinner
//                   as="span"
//                   animation="border"
//                   size="sm"
//                   role="status"
//                   style={{
//                     width: "0.8rem",
//                     height: "0.8rem",
//                     borderWidth: "0.15em",
//                   }}
//                   className="me-2"
//                 />
//                 Loading...
//               </>
//             ) : (
//               "Update"
//             )}
//           </Button>
//         </Form.Group>

//         <Form.Label htmlFor="dob">Date of birth</Form.Label>
//         <Form.Control
//           type="date"
//           id="dob"
//           value={formData.dob}
//           onChange={onHandleChange}
//         />

//         <Form.Label htmlFor="address">Address</Form.Label>
//         <Form.Control
//           type="text"
//           id="address"
//           value={formData.address}
//           onChange={onHandleChange}
//         />

//         <Form.Label htmlFor="state">State</Form.Label>
//         <Form.Control
//           type="text"
//           id="state"
//           value={formData.state}
//           onChange={onHandleChange}
//         />

//         <Form.Label htmlFor="district">District</Form.Label>
//         <Form.Control
//           type="text"
//           id="district"
//           value={formData.district}
//           onChange={onHandleChange}
//         />

//         <Form.Label htmlFor="pincode">Pincode</Form.Label>
//         <Form.Control
//           type="text"
//           id="pincode"
//           value={formData.pincode}
//           onChange={onHandleChange}
//         />

//         <Form.Label htmlFor="contact_number">Contact number</Form.Label>
//         <Form.Control
//           type="text"
//           id="contact_number"
//           value={formData.contact_number}
//           onChange={onHandleChange}
//         />

//         <Form.Label htmlFor="alternative_number">Alternative number</Form.Label>
//         <Form.Control
//           type="text"
//           id="alternative_number"
//           value={formData.alternative_number}
//           onChange={onHandleChange}
//         />

//         <h4 style={{ marginTop: "20px" }}>Add Account</h4>

//         <Form.Label htmlFor="bank_name">Bank Name</Form.Label>
//         <Form.Control
//           type="text"
//           id="bank_name"
//           value={formData.bank_name}
//           onChange={onHandleChange}
//         />

//         <Form.Label htmlFor="account_name">Accountant Name</Form.Label>
//         <Form.Control
//           type="text"
//           id="account_name"
//           value={formData.account_name}
//           onChange={onHandleChange}
//         />

//         <Form.Label htmlFor="account_number">Account number</Form.Label>
//         <Form.Control
//           type="text"
//           id="account_number"
//           value={formData.account_number}
//           onChange={onHandleChange}
//         />

//         <Form.Label htmlFor="ifsc_code">IFSC Code</Form.Label>
//         <Form.Control
//           type="text"
//           id="ifsc_code"
//           value={formData.ifsc_code}
//           onChange={onHandleChange}
//         />

//         <Form.Label htmlFor="branch_name">Branch Name</Form.Label>
//         <Form.Control
//           type="text"
//           id="branch_name"
//           value={formData.branch_name}
//           onChange={onHandleChange}
//         />

//         <button type="submit" disabled={status.result === false}>
//           Submit
//         </button>
//       </form>
//       <ToastContainer />
//     </div>
//   );
// };

// export default Myprofile;


import React, { useState, useEffect } from "react";
import "./Myprofile.scss";
import Form from "react-bootstrap/Form";
import { useLocation } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { Button, Spinner } from "react-bootstrap";
import APP_BASE_URL from "../../components/Api/globalApi";

const Myprofile = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const data = location.state?.data || {};
  const status = location.state?.status || {};
  console.log('Status:', status, 'Data:', data);

  // Initialize form data with proper field mapping from API response
  const getInitialFormData = () => {
    // If status has data (profile exists), use that data with proper field mapping
    if (status.data) {
      const profileData = status.data;
      console.log('Profile Data from API:', profileData); // Debug log

      return {
        first_name: profileData.first_name || profileData.u_first_name || data.user_name || "",
        dob: profileData.dob ? moment(profileData.dob).format("YYYY-MM-DD") : "",
        address: profileData.address || profileData.u_address || "",
        state: profileData.state || profileData.u_state || "",
        district: profileData.district || profileData.u_district || "",
        pincode: profileData.pincode || profileData.u_pincode || "",
        contact_number: profileData.contact_number || profileData.u_mobile || data.user_mobile || "",
        alternative_number: profileData.alternative_number || profileData.u_alt_no || "",
        bank_name: profileData.bank_name || profileData.b_name || "",
        account_name: profileData.account_name || profileData.acc_name || "",
        account_number: profileData.account_number || profileData.acc_number || "",
        ifsc_code: profileData.ifsc_code || "",
        branch_name: profileData.branch_name || "",
        image: profileData.image ? `https://api.springwayhub.com/${profileData.image}` : "",
      };
    }

    // If no profile data exists, use basic data
    return {
      first_name: data.user_name || "",
      dob: "",
      address: "",
      state: "",
      district: "",
      pincode: "",
      contact_number: data.user_mobile || "",
      alternative_number: "",
      bank_name: "",
      account_name: "",
      account_number: "",
      ifsc_code: "",
      branch_name: "",
      image: "",
    };
  };

  const [formData, setFormData] = useState(getInitialFormData);
  const [image, setImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(
    status.data?.image ? `https://api.springwayhub.com/${status.data.image}` : null
  );
  const [Loading, setLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Update form data when location state changes
  useEffect(() => {
    console.log('Location state changed:', location.state);
    const newFormData = getInitialFormData();
    console.log('New form data:', newFormData);
    setFormData(newFormData);

    if (status.data?.image) {
      setImagePreview(`https://api.springwayhub.com/${status.data.image}`);
    }
  }, [location.state]);

  // Debug effect to log current form data
  useEffect(() => {
    console.log('Current form data:', formData);
  }, [formData]);

  const notify = (message, type = "success") => {
    if (type === "success") {
      toast.success(message);
    } else {
      toast.error(message);
    }
  };

  const onHandleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [id]: value,
    }));
  };

  const handleImage = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);

      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleButtonClick = async (e) => {
    e.preventDefault();
    if (!formData.first_name.trim()) {
      notify("Please enter a username", "error");
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(
        `${APP_BASE_URL}/update/username`,
        { username: formData.first_name },
        {
          headers: {
            u_id: data.user_id,
          },
        }
      );

      if (response.data.result) {
        notify("Username updated successfully!");
      } else {
        notify(response.data.message || "Failed to update username", "error");
      }
    } catch (error) {
      console.error("Error updating username:", error);
      notify("Failed to update username", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const formDataToSend = new FormData();

      // Append all form fields - use the exact field names your API expects
      formDataToSend.append("first_name", formData.first_name);
      formDataToSend.append("dob", formData.dob);
      formDataToSend.append("address", formData.address);
      formDataToSend.append("state", formData.state);
      formDataToSend.append("district", formData.district);
      formDataToSend.append("pincode", formData.pincode);
      formDataToSend.append("contact_number", formData.contact_number);
      formDataToSend.append("alternative_number", formData.alternative_number);
      formDataToSend.append("bank_name", formData.bank_name);
      formDataToSend.append("account_name", formData.account_name);
      formDataToSend.append("account_number", formData.account_number);
      formDataToSend.append("ifsc_code", formData.ifsc_code);
      formDataToSend.append("branch_name", formData.branch_name);

      // Append the actual image file if selected
      if (image) {
        formDataToSend.append("image", image);
      }

      console.log('Sending form data with user_id:', data.user_id);
      console.log('Form data being sent:', Object.fromEntries(formDataToSend));

      const response = await axios.post(
        `${APP_BASE_URL}/myprofile`,
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            "user-id": data.user_id,
            "api-key": data.user_api_key,
            user_id: data.user_id,
            api_key: data.user_api_key,
          },
        }
      );

      console.log('Profile update response:', response.data);

      if (response.data.result === true) {
        notify("Profile updated successfully!");
        setTimeout(() => {
          navigate("/home");
        }, 2000);
      } else {
        notify(response.data.message || "Failed to update profile", "error");
      }
    } catch (error) {
      console.error("Error updating profile:", error);
      notify("An error occurred while updating profile", "error");
    } finally {
      setIsSubmitting(false);
    }
  };

  const imageFixer =
    imagePreview ||
    "https://static.vecteezy.com/system/resources/thumbnails/005/544/718/small_2x/profile-icon-design-free-vector.jpg";

  return (
    <div className="container-fluid pro">
      <form onSubmit={handleSubmit}>
        <h4>My Profile</h4>

        <div className="pro-image">
          <Form.Label htmlFor="image-upload" className="btn btn-outline-primary mb-3">
            Choose Profile Image
          </Form.Label>
          <Form.Control
            id="image-upload"
            className="control d-none"
            type="file"
            name="image"
            accept="image/*"
            onChange={handleImage}
          />
          <div className="image-holder mt-3">
            <img
              src={imageFixer}
              alt="Preview"
              style={{
                maxWidth: "200px",
                maxHeight: "200px",
                borderRadius: "8px",
                border: "2px solid #ddd"
              }}
            />
          </div>
        </div>

        <Form.Group className="d-flex align-items-center mb-3">
          <div className="flex-grow-1 me-2">
            <Form.Label htmlFor="first_name">User Name</Form.Label>
            <Form.Control
              type="text"
              id="first_name"
              value={formData.first_name}
              onChange={onHandleChange}
              placeholder="Enter your username"
            />
          </div>
          <Button
            variant="primary"
            type="button"
            onClick={handleButtonClick}
            disabled={Loading || !formData.first_name.trim()}
            style={{
              marginTop: "1.5rem",
              minWidth: "100px",
            }}
          >
            {Loading ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  className="me-2"
                />
                Updating...
              </>
            ) : (
              "Update"
            )}
          </Button>
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label htmlFor="dob">Date of birth</Form.Label>
          <Form.Control
            type="date"
            id="dob"
            value={formData.dob}
            onChange={onHandleChange}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label htmlFor="address">Address</Form.Label>
          <Form.Control
            type="text"
            id="address"
            value={formData.address}
            onChange={onHandleChange}
            placeholder="Enter your address"
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label htmlFor="state">State</Form.Label>
          <Form.Control
            type="text"
            id="state"
            value={formData.state}
            onChange={onHandleChange}
            placeholder="Enter your state"
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label htmlFor="district">District</Form.Label>
          <Form.Control
            type="text"
            id="district"
            value={formData.district}
            onChange={onHandleChange}
            placeholder="Enter your district"
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label htmlFor="pincode">Pincode</Form.Label>
          <Form.Control
            type="text"
            id="pincode"
            value={formData.pincode}
            onChange={onHandleChange}
            placeholder="Enter pincode"
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label htmlFor="contact_number">Contact number</Form.Label>
          <Form.Control
            type="text"
            id="contact_number"
            value={formData.contact_number}
            onChange={onHandleChange}
            placeholder="Enter contact number"
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label htmlFor="alternative_number">Alternative number</Form.Label>
          <Form.Control
            type="text"
            id="alternative_number"
            value={formData.alternative_number}
            onChange={onHandleChange}
            placeholder="Enter alternative number"
          />
        </Form.Group>

        <h4 style={{ marginTop: "20px", marginBottom: "20px" }}>Bank Account Details</h4>

        <Form.Group className="mb-3">
          <Form.Label htmlFor="bank_name">Bank Name</Form.Label>
          <Form.Control
            type="text"
            id="bank_name"
            value={formData.bank_name}
            onChange={onHandleChange}
            placeholder="Enter bank name"
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label htmlFor="account_name">Account Holder Name</Form.Label>
          <Form.Control
            type="text"
            id="account_name"
            value={formData.account_name}
            onChange={onHandleChange}
            placeholder="Enter account holder name"
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label htmlFor="account_number">Account number</Form.Label>
          <Form.Control
            type="text"
            id="account_number"
            value={formData.account_number}
            onChange={onHandleChange}
            placeholder="Enter account number"
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label htmlFor="ifsc_code">IFSC Code</Form.Label>
          <Form.Control
            type="text"
            id="ifsc_code"
            value={formData.ifsc_code}
            onChange={onHandleChange}
            placeholder="Enter IFSC code"
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label htmlFor="branch_name">Branch Name</Form.Label>
          <Form.Control
            type="text"
            id="branch_name"
            value={formData.branch_name}
            onChange={onHandleChange}
            placeholder="Enter branch name"
          />
        </Form.Group>

        <Button
          type="submit"
          variant="success"
          size="lg"
          disabled={isSubmitting}
          className="w-100 mt-4"
        >
          {isSubmitting ? (
            <>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                className="me-2"
              />
              Updating Profile...
            </>
          ) : (
            "Update Profile"
          )}
        </Button>
      </form>
      <ToastContainer />
    </div>
  );
};

export default Myprofile;